const ordercategoryprocess = {
    getlist: 'ordercategoryprocess/getlist',
    add: 'ordercategoryprocess/add',
    update: 'ordercategoryprocess/update',
    remove: 'ordercategoryprocess/remove',
    get: 'ordercategoryprocess/get',
    getall: 'ordercategoryprocess/getall',
    clearcache: 'ordercategoryprocess/clear-cache',
}
export default ordercategoryprocess
